import React from 'react'
import clsx from 'classnames'
import { Link } from 'react-router'
import styles from './SalonsModePicker.module.css'

export type SalonsMode = 'map' | 'list'

type SalonsModePickerProps = {
  mode: SalonsMode,
  onToggle: () => void,
}

/** «карта | список | все» switch above the salons */
export const SalonsModePicker: React.FC<SalonsModePickerProps> = (props) => {
  const { mode, onToggle } = props
  const mapClassName = clsx({
    [styles.textContainerRight]: true,
    [styles.textContainerRightMap]: mode === 'map',
  })
  const listClassName = clsx({
    [styles.textContainerRight]: true,
    [styles.textContainerRightList]: mode === 'list',
  })
  const separator = <>
    <span className={styles.rightContainerSybol}>|</span>
    <span className={styles.rightContainerSybolMobile}>|</span>
  </>

  return (
    <div className={styles.container}>
      <div className={styles.menuContainer}>
        <div className={styles.insideMenu}>
          <span className={mapClassName} onClick={onToggle}>карта</span>
          {separator}
          <span className={listClassName} onClick={onToggle}>список</span>
          {separator}
          <Link to={'/salons'} className={listClassName} onClick={onToggle}>все</Link>
        </div>
      </div>
    </div>
  )
}
